import { render, staticRenderFns } from "./BankAccountRegistration.vue?vue&type=template&id=d7171962&"
import script from "./BankAccountRegistration.vue?vue&type=script&lang=js&"
export * from "./BankAccountRegistration.vue?vue&type=script&lang=js&"
import style0 from "./BankAccountRegistration.vue?vue&type=style&index=0&id=d7171962&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports